import { Privileges } from "../../constants/privileges";
import { Roles } from "../../constants/roles";
import { PrivilegeConfig } from "./models/privilege.model";

export const privilegesLinks: PrivilegeConfig[] = [
    {
        menuId: 'member',
        menuLabel: 'Members',
        customerAssistanceToolsHeading: 'Customer Assistance Tools',
        adminToolsHeading: 'AdminTools',
        isActive: true,
        accessIds: [Roles.SUPER_ADMIN, Privileges.MEMBERS, Privileges.MEMBER_RESTRICT, Privileges.MANAGE_SHIFTED_MEMBERS],
        customerAssistanceTools: [
            {
                subMenuId: 'searchMemberAccount',
                subMenuLabel: 'Search Member Account',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.MEMBERS],
                subPrivilege: [{
                    subMenuId: 'recycleMemberAccount',
                    subMenuLabel: 'Recycle Member Account',
                    hasAccess: true,
                    accessIds: [Roles.SUPER_ADMIN, Privileges.RECYCLE_MEMBER_ACCOUNT]
                }]
            },
            {
                subMenuId: 'eobDelivery',
                subMenuLabel: 'EOB Delivery',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.MEMBERS],
                subPrivilege: []
            },
            {
                subMenuId: 'none',
                subMenuLabel: 'None',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.MEMBERS],
                subPrivilege: []
            }
        ],
        adminTools: [
            {
                subMenuId: 'memberRestrictions',
                subMenuLabel: 'Member Restrictions',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Privileges.MEMBER_RESTRICT],
                subPrivilege: []
            },
            {
                subMenuId: 'manageShiftedMembers',
                subMenuLabel: 'Manage Shifted Members',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Privileges.MANAGE_SHIFTED_MEMBERS],
                subPrivilege: []
            },         
            {
                subMenuId: 'manageFindAProvider',
                subMenuLabel: 'Manage Find a Provider',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Privileges.FAP],
                subPrivilege: [
                    {
                        subMenuId: 'viewData',
                        subMenuLabel: 'View Data',
                        hasAccess: true,
                        accessIds: [Roles.SUPER_ADMIN, Privileges.FAP_VIEW_DATA]
                    },
                    {
                        subMenuId: 'editData',
                        subMenuLabel: 'Edit Data',
                        hasAccess: true,
                        accessIds: [Roles.SUPER_ADMIN, Privileges.FAP_EDIT_DATA]
                    },
                    {
                        subMenuId: 'addData',
                        subMenuLabel: 'Add Data',
                        hasAccess: true,
                        accessIds: [Roles.SUPER_ADMIN, Privileges.FAP_ADD_DATA]
                    },
                    {
                        subMenuId: 'deleteData',
                        subMenuLabel: 'Delete Data',
                        hasAccess: true,
                        accessIds: [Roles.SUPER_ADMIN, Privileges.FAP_DELETE_DATA]
                    },
                    {
                        subMenuId: 'runReports',
                        subMenuLabel: 'Run Reports',
                        hasAccess: true,
                        accessIds: [Roles.SUPER_ADMIN, Privileges.FAP_REPORTS]
                    }

                ]
            },
            {
                subMenuId: 'ifpProductData',
                subMenuLabel: 'IFP Product Data Upload',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN],
                subPrivilege: []
            },
            {
                subMenuId: 'none',
                subMenuLabel: 'None',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Privileges.MEMBERS, Privileges.MEMBER_RESTRICT, Privileges.MANAGE_SHIFTED_MEMBERS],
                subPrivilege: []
            }
        ]
    },
    {
        menuId: 'provider',
        menuLabel: 'Provider',
        customerAssistanceToolsHeading: 'Customer Assistance Tools',
        adminToolsHeading: 'AdminTools',
        isActive: true,
        accessIds: [Roles.SUPER_ADMIN, Privileges.PROVIDERS, Privileges.PROVIDER_REPORTS],
        customerAssistanceTools: [
            {
                subMenuId: 'searchProviderAccount',
                subMenuLabel: 'Search Provider account',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.PROVIDERS],
                subPrivilege: []
            },
            {
                subMenuId: 'searchProviderRecord',
                subMenuLabel: 'Search Provider Record',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.PROVIDERS],
                subPrivilege: []
            },
            {
                subMenuId: 'none',
                subMenuLabel: 'None',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.PROVIDERS],
                subPrivilege: []
            }
        ],
        adminTools: [
            {
                subMenuId: 'lockTaxId',
                subMenuLabel: 'Lock Tax ID',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Privileges.LOCK_TAXID],
                subPrivilege: []
            },
            {
                subMenuId: 'providerReports',
                subMenuLabel: 'Provider Reports',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Privileges.PROVIDER_REPORTS],
                subPrivilege: []
            }
        ]
    },
    {
        menuId: 'employer',
        menuLabel: 'Employer',
        customerAssistanceToolsHeading: 'Customer Assistance Tools',
        adminToolsHeading: 'AdminTools',
        isActive: true,
        accessIds: [Roles.SUPER_ADMIN, Privileges.EMPLOYERS, Privileges.EMPLOYER_SURVEY_REPORT],
        customerAssistanceTools: [
            {
                subMenuId: 'searchEmployerUser',
                subMenuLabel: 'Search Employer User',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.EMPLOYERS],
                subPrivilege: []
            },
            {
                subMenuId: 'searchEmployerGroups',
                subMenuLabel: 'Search Employer Groups',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.EMPLOYERS],
                subPrivilege: []
            },
            {
                subMenuId: 'exceptionList',
                subMenuLabel: 'Exception List',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.EMPLOYERS],
                subPrivilege: []
            }, {
                subMenuId: 'registration-report',
                subMenuLabel: 'Registration Report',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.EMPLOYERS],
                subPrivilege: []
            },
            {
                subMenuId: 'payment-report',
                subMenuLabel: 'Payment Report',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.EMPL_BILLING_ACCESS],
                subPrivilege: []
            },
            {
                subMenuId: 'healthcareSpendingReport',
                subMenuLabel: 'Prescription Drug and Healthcare Spending Report',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.EMPLOYER_SURVEY_REPORT],
                subPrivilege: []
            },
            {
                subMenuId: 'whyzenEmployerReporting',
                subMenuLabel: 'Whyzen Employer Reporting',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE],
                subPrivilege: []
            }
        ],
        adminTools: []
    },
    {
        menuId: 'selfFunded',
        menuLabel: 'Self-Funded Portal',
        customerAssistanceToolsHeading: 'Customer Assistance Tools',
        adminToolsHeading: null,
        isActive: true,
        // MDC-514898 - added included health to displaye under My Privileges section in My Profile screen (IH - Included Health, ACC - Accolade).
        accessIds: [Roles.SUPER_ADMIN, Privileges.TPA_SEARCH, Privileges.TPA_CREATEUSER, Privileges.TPA_LOGIN, Privileges.TPA_SPOOF, Privileges.TPA_LOGIN, Privileges.ASO, Privileges.TPA, Privileges.TPA_EXTERNAL_NOTIFICATIONS, Privileges.TPA_USER_DASHBOARD, Privileges.TPA_AUTHORIZATION_CLINICAL_NOTES, Privileges.TPA_ACCOUNTING, Privileges.ACC, Privileges.IH],
        customerAssistanceTools: [
            {
                subMenuId: 'tpa',
                subMenuLabel: 'TPA',
                hasAccess: true,
                selfFundedFlag: true,
                accessIds: [Privileges.TPA],
                subPrivilege: [
                    {
                        subMenuId: 'searchUser',
                        subMenuLabel: 'Search User',
                        hasAccess: true,
                        accessIds: [Privileges.TPA, Privileges.TPA_SEARCH]
                    },
                    {
                        subMenuId: 'spoofUser',
                        subMenuLabel: 'Spoof User',
                        hasAccess: true,
                        accessIds: [Privileges.TPA, Privileges.TPA_SPOOF]
                    },
                    {
                        subMenuId: 'createOrModifyUser',
                        subMenuLabel: 'Create/Modify User',
                        hasAccess: true,
                        accessIds: [Privileges.TPA, Privileges.TPA_CREATEUSER]
                    },
                    {
                        subMenuId: 'loginToSelfFundedPortal',
                        subMenuLabel: 'Login to Self-Funded Portal',
                        hasAccess: true,
                        accessIds: [Privileges.TPA, Privileges.TPA_LOGIN]
                    },
                    {
                        subMenuId: 'externalNotifications',
                        subMenuLabel: 'External Notifications',
                        hasAccess: true,
                        accessIds: [Privileges.TPA, Privileges.TPA_EXTERNAL_NOTIFICATIONS]
                    },
                    {
                        subMenuId: 'userDashboard',
                        subMenuLabel: 'User Dashboard',
                        hasAccess: true,
                        accessIds: [Privileges.TPA, Privileges.TPA_USER_DASHBOARD]
                    },
                    {
                        subMenuId: 'authorizationWithClinicalNotes',
                        subMenuLabel: 'Authorization with Clinical notes',
                        hasAccess: true,
                        accessIds: [Privileges.TPA, Privileges.TPA_AUTHORIZATION_CLINICAL_NOTES]
                    },
                    {
                        subMenuId: 'accounting',
                        subMenuLabel: 'Accounting',
                        hasAccess: true,
                        accessIds: [Privileges.TPA, Privileges.TPA_ACCOUNTING]
                    }
                ]
            },
            {
                subMenuId: 'aso',
                subMenuLabel: 'ASO',
                hasAccess: true,
                selfFundedFlag: true,
                accessIds: [Privileges.ASO],
                subPrivilege: [
                    {
                        subMenuId: 'searchUser',
                        subMenuLabel: 'Search User',
                        hasAccess: true,
                        accessIds: [Privileges.ASO, Privileges.TPA_SEARCH]
                    },
                    {
                        subMenuId: 'spoofUser',
                        subMenuLabel: 'Spoof User',
                        hasAccess: true,
                        accessIds: [Privileges.ASO, Privileges.TPA_SPOOF]
                    },
                    {
                        subMenuId: 'createOrModifyUser',
                        subMenuLabel: 'Create/Modify User',
                        hasAccess: true,
                        accessIds: [Privileges.ASO, Privileges.TPA_CREATEUSER]
                    },
                    {
                        subMenuId: 'loginToSelfFundedPortal',
                        subMenuLabel: 'Login to Self-Funded Portal',
                        hasAccess: true,
                        accessIds: [Privileges.ASO, Privileges.TPA_LOGIN]
                    },
                    {
                        subMenuId: 'externalNotifications',
                        subMenuLabel: 'External Notifications',
                        hasAccess: true,
                        accessIds: [Privileges.ASO, Privileges.TPA_EXTERNAL_NOTIFICATIONS]
                    },
                    {
                        subMenuId: 'userDashboard',
                        subMenuLabel: 'User Dashboard',
                        hasAccess: true,
                        accessIds: [Privileges.ASO, Privileges.TPA_USER_DASHBOARD]
                    },
                    {
                        subMenuId: 'authorizationWithClinicalNotes',
                        subMenuLabel: 'Authorization with Clinical notes',
                        hasAccess: true,
                        accessIds: [Privileges.ASO, Privileges.TPA_AUTHORIZATION_CLINICAL_NOTES]
                    }
                ]
            },
            {
                subMenuId: 'accolade',
                subMenuLabel: 'Accolade',
                hasAccess: true,
                selfFundedFlag: true,
                accessIds: [Privileges.ACC],
                subPrivilege: [
                    {
                        subMenuId: 'searchUser',
                        subMenuLabel: 'Search User',
                        hasAccess: true,
                        accessIds: [Privileges.ACC, Privileges.TPA_SEARCH]
                    },
                    {
                        subMenuId: 'spoofUser',
                        subMenuLabel: 'Spoof User',
                        hasAccess: true,
                        accessIds: [Privileges.ACC, Privileges.TPA_SPOOF]
                    },
                    {
                        subMenuId: 'createOrModifyUser',
                        subMenuLabel: 'Create/Modify User',
                        hasAccess: true,
                        accessIds: [Privileges.ACC, Privileges.TPA_CREATEUSER]
                    },
                    {
                        subMenuId: 'loginToSelfFundedPortal',
                        subMenuLabel: 'Login to Self-Funded Portal',
                        hasAccess: true,
                        accessIds: [Privileges.ACC, Privileges.TPA_LOGIN]
                    },
                    {
                        subMenuId: 'externalNotifications',
                        subMenuLabel: 'External Notifications',
                        hasAccess: true,
                        accessIds: [Privileges.ACC, Privileges.TPA_EXTERNAL_NOTIFICATIONS]
                    },
                    {
                        subMenuId: 'userDashboard',
                        subMenuLabel: 'User Dashboard',
                        hasAccess: true,
                        accessIds: [Privileges.ACC, Privileges.TPA_USER_DASHBOARD]
                    },
                    {
                        subMenuId: 'authorizationWithClinicalNotes',
                        subMenuLabel: 'Authorization with Clinical notes',
                        hasAccess: true,
                        accessIds: [Privileges.ACC, Privileges.TPA_AUTHORIZATION_CLINICAL_NOTES]
                    }
                ]
            },
            // MDC-514898 Included Health sub menu will be displayed only if the created user has Included Health user type (IH - Included Health, ACC - Accolade).
            {
                subMenuId: 'includedHealth',
                subMenuLabel: 'Included Health',
                hasAccess: true,
                selfFundedFlag: true,
                accessIds: [Privileges.IH],
                subPrivilege: [
                    {
                        subMenuId: 'searchUser',
                        subMenuLabel: 'Search User',
                        hasAccess: true,
                        accessIds: [Privileges.IH, Privileges.TPA_SEARCH]
                    },
                    {
                        subMenuId: 'spoofUser',
                        subMenuLabel: 'Spoof User',
                        hasAccess: true,
                        accessIds: [Privileges.IH, Privileges.TPA_SPOOF]
                    },
                    {
                        subMenuId: 'createOrModifyUser',
                        subMenuLabel: 'Create/Modify User',
                        hasAccess: true,
                        accessIds: [Privileges.IH, Privileges.TPA_CREATEUSER]
                    },
                    {
                        subMenuId: 'loginToSelfFundedPortal',
                        subMenuLabel: 'Login to Self-Funded Portal',
                        hasAccess: true,
                        accessIds: [Privileges.IH, Privileges.TPA_LOGIN]
                    },
                    {
                        subMenuId: 'externalNotifications',
                        subMenuLabel: 'External Notifications',
                        hasAccess: true,
                        accessIds: [Privileges.IH, Privileges.TPA_EXTERNAL_NOTIFICATIONS]
                    },
                    {
                        subMenuId: 'userDashboard',
                        subMenuLabel: 'User Dashboard',
                        hasAccess: true,
                        accessIds: [Privileges.IH, Privileges.TPA_USER_DASHBOARD]
                    },
                    {
                        subMenuId: 'authorizationWithClinicalNotes',
                        subMenuLabel: 'Authorization with Clinical notes',
                        hasAccess: true,
                        accessIds: [Privileges.IH, Privileges.TPA_AUTHORIZATION_CLINICAL_NOTES]
                    }
                ]
            }
        ],
        adminTools: []
    },
    {
        menuId: 'producer',
        menuLabel: 'Producer',
        customerAssistanceToolsHeading: 'Customer Assistance Tools',
        adminToolsHeading: 'AdminTools',
        isActive: true,
        accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE],
        customerAssistanceTools: [
            {
                subMenuId: 'manageProducerUser',
                subMenuLabel: 'Manage Producer User',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.PRODUCER_SEARCH_PRODUCER],
                subPrivilege: []
            },
            {
                subMenuId: 'brokerConnection',
                subMenuLabel: 'Broker Connection',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.PRODUCER_BROKER_CONNECTION],
                subPrivilege: []
            }
        ],
        adminTools: [
            {
                subMenuId: 'createNewBrokerAnalyst',
                subMenuLabel: 'Create New Broker Analyst',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.PRODUCER_NEW_BROKER_ANALYST],
                subPrivilege: []
            },
            {
                subMenuId: 'directDepositReport',
                subMenuLabel: 'Direct Deposit',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.PRODUCER_DIRECT_DEPOSIT],
                subPrivilege: []
            },
            {
                subMenuId: 'generateUrlMedicare',
                subMenuLabel: 'Generate Url - Medicare',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.PRODUCER_MEDICARE],
                subPrivilege: []
            },
            {
                subMenuId: 'generateBrokerReports',
                subMenuLabel: 'Generate Broker reports',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Privileges.PRODUCER_GENERATE_BROKER_REPORTS],
                subPrivilege: []
            }
        ]
    },
    {
        menuId: 'prospect',
        menuLabel: 'Prospect',
        customerAssistanceToolsHeading: 'Customer Assistance Tools',
        adminToolsHeading: 'AdminTools',
        isActive: true,
        accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE],
        customerAssistanceTools: [
            {
                subMenuId: 'zipariPlansAndEnroll',
                subMenuLabel: 'Zipari plans & Enroll',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.SEARCH_PROSPECT],
                subPrivilege: []
            },
            {
                subMenuId: 'ifpEnrollments',
                subMenuLabel: 'IFP enrollments',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.SEARCH_PROSPECT],
                subPrivilege: []
            },
            {
                subMenuId: 'userAccountActivation',
                subMenuLabel: 'User Account Activation',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.SEARCH_PROSPECT],
                subPrivilege: []
            },
            {
                subMenuId: 'medicarePlansAndEnroll',
                subMenuLabel: 'Medicare Plans & Enroll',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.SEARCH_PROSPECT],
                subPrivilege: []
            }
        ],
        adminTools: [
            {
                subMenuId: 'openAdminTool',
                subMenuLabel: 'Open Admin Tool',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Privileges.OPEN_ADMIN_TOOL],
                subPrivilege: []
            },
            {
                subMenuId: 'noneProspect',
                subMenuLabel: 'None',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Privileges.OPEN_ADMIN_TOOL],
                subPrivilege: []
            }
        ]
    },
    {
        menuId: 'benefits',
        menuLabel: 'Benefits',
        customerAssistanceToolsHeading: 'Customer Assistance Tools',
        adminToolsHeading: 'AdminTools',
        isActive: true,
        accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.CUSTOM],
        customerAssistanceTools: [
            {
                subMenuId: 'benefitLookup',
                subMenuLabel: 'Benefit Lookup',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE],
                subPrivilege: []
            }
        ],
        adminTools: [
            {
                subMenuId: 'customBenefits',
                subMenuLabel: 'Custom Benefit / Custom Web Display',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Privileges.CUSTOM],
                subPrivilege: []
            },
            {
                subMenuId: 'addCustomization',
                subMenuLabel: 'Add Customization',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Privileges.CUSTOM_ADD],
                subPrivilege: []
            },
            {
                subMenuId: 'none',
                subMenuLabel: 'None',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Privileges.CUSTOM_ADD, Privileges.CUSTOM],
                subPrivilege: []
            }
        ]
    },
    {
        menuId: 'manageCsa',
        menuLabel: 'Manage CSA',
        customerAssistanceToolsHeading: 'Customer Assistance Tools',
        adminToolsHeading: 'AdminTools',
        isActive: true,
        accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER],
        customerAssistanceTools: [
            {
                subMenuId: 'myProfile',
                subMenuLabel: 'My Profile',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER],
                subPrivilege: []
            },
            {
                subMenuId: 'createOrModifyCsaUsers',
                subMenuLabel: 'Create/Modify CSA Users',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER],
                subPrivilege: []
            }
        ],
        adminTools: [
            {
                subMenuId: 'csaUserReport',
                subMenuLabel: 'CSA User Report',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER],
                subPrivilege: []
            },
            {
                subMenuId: 'providerActivityReport',
                subMenuLabel: 'Provider Activity Report',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER],
                subPrivilege: []
            },
            {
                subMenuId: 'employerActivityReport',
                subMenuLabel: 'Employer Activity Report',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER],
                subPrivilege: []
            },
            {
                subMenuId: 'memberActivityReport',
                subMenuLabel: 'Member Activity Report',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER],
                subPrivilege: []
            },
            {
                subMenuId: 'prospectActivityReport',
                subMenuLabel: 'Prospect Activity Report',
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER],
                subPrivilege: []
            }

        ]
    },
    {
        menuId: 'hicnMbi',
        menuLabel: 'HICN MBI',
        customerAssistanceToolsHeading: null,
        adminToolsHeading: null,
        isActive: true,
        accessIds: [Roles.SUPER_ADMIN, Privileges.MEMBER_HICNMBI],
        customerAssistanceTools: [
            {
                subMenuId: 'hicnMbiLookup',
                subMenuLabel: 'HICN MBI Lookup',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.MEMBER_HICNMBI],
                subPrivilege: []
            }
        ],
        adminTools: []
    },
    {
        menuId: 'ccm',
        menuLabel: 'CCM',
        customerAssistanceToolsHeading: null,
        adminToolsHeading: null,
        isActive: true,
        accessIds: [Roles.SUPER_ADMIN, Privileges.CCM_MEMBER, Privileges.CCM_PROVIDER, Privileges.CCM_PRODUCER, Privileges.CCM_EMPLOYER, Privileges.CCM_PROSPECT, Privileges.CCM_NONMEMBER],
        customerAssistanceTools: [
            {
                subMenuId: 'member',
                subMenuLabel: 'Member',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.CCM_MEMBER],
                subPrivilege: []
            },
            {
                subMenuId: 'provider',
                subMenuLabel: 'Provider',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.CCM_PROVIDER],
                subPrivilege: []
            },
            {
                subMenuId: 'producer',
                subMenuLabel: 'Producer',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.CCM_PRODUCER],
                subPrivilege: []
            },
            {
                subMenuId: 'employer',
                subMenuLabel: 'Employer',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.CCM_EMPLOYER],
                subPrivilege: []
            },
            {
                subMenuId: 'prospect',
                subMenuLabel: 'Prospect',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.CCM_PROSPECT],
                subPrivilege: []
            },
            {
                subMenuId: 'nonMember',
                subMenuLabel: 'Non-Member',
                hasAccess: true,
                selfFundedFlag: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.CCM_NONMEMBER],
                subPrivilege: []
            }
        ],
        adminTools: []
    }
]
